module.exports = __webpack_public_path__ + "static/media/Athlete.72985e3f.jpg";